module.exports = __webpack_public_path__ + "img/tpc-posters-2.d093133c.jpg";